"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const makeGroupBySingleFieldPointerMethod_1 = require("../makeGroupBySingleFieldPointerMethod");
exports.concentrationLimitPointerMethods = [
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'employer_name', // Using this instead of employer_id since that's how it's set up in the template
        method: 'rainClearHaven1.singleEmployer',
        type: 'string',
    }),
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map